import type { ReactNode } from "react";
import type { LoyaltyLeaderboardEntry } from "Components/Loyalty/Shared/Leaderboard/types";
import { LeaderboardItem } from "Components/Shared/LeaderboardItem/LeaderboardItem";
import { getContextProfilePhotoUrl } from "Utils/Image/getProfilePhotoUrl";

type Props = {
  entry: LoyaltyLeaderboardEntry;
  anonymousLabel: string;
  scoreIcon: ReactNode;
};

export const LeaderboardEntry = ({
  entry: {
    identityUserPublicId,
    profilePicture,
    rank,
    name,
    totalPoints,
    isCurrentUser,
  },
  anonymousLabel,
  scoreIcon,
}: Props) => {
  const photoUrl = getContextProfilePhotoUrl(
    identityUserPublicId,
    profilePicture,
  );

  return (
    <LeaderboardItem
      rank={rank}
      name={name || anonymousLabel}
      score={totalPoints}
      scoreIcon={scoreIcon}
      profilePicture={photoUrl ?? null}
      isAnonymous={!name}
      isCurrentUser={isCurrentUser}
    />
  );
};
